@for (price of pricing; track $index) {
@if (price) {
<ui-price-product [price]="price" [hint]="hint"></ui-price-product>
}
}